import toNumber from 'lodash/toNumber'

const gtmProductImpression = ({ products = [], listName = '' }) => {
	const renameProductKey = products.map((item, index) => {
		return {
			item_name: item.productname,
			item_id: item.productcode,
			price: toNumber(item.special_priceforsales),
			item_brand: item.brands?.brandname,
			item_category: item.categories?.categoryname,
			item_list_name: listName,
			index: index + 1,
		};
	});

	window.gtag("event", "view_item_list", {
		item_list_name: listName,
		items: renameProductKey
	});
};

const gtmProductClick = ({ product = {}, listName = '' }) => {
	window.gtag('event', 'select_item', {
		item_list_name: listName,
		items: [
			{
				item_id: product?.productcode,
				item_name: product?.productname,
				item_brand: product?.brands?.brandname,
				item_category: product?.categories?.categoryname,
				item_list_name: listName,
				price: toNumber(product?.special_priceforsales)
			}
		]
	});
};

const gtmProductDetail = ({ product = {}, listName = '' }) => {
	window.gtag("event", "view_item", {
		currency: "THB",
		value: toNumber(product?.special_priceforsales),
		items: [
			{
				item_id: product?.productcode,
				item_name: product?.productname,
				item_brand: product?.brands?.brandname,
				item_category: product?.categories?.categoryname,
				item_list_name: listName,
				price: toNumber(product?.special_priceforsales)
			}
		]
	});
};

const gtmProductAddToCart = ({ products = [] }) => {
	let valueTotal = 0;
	const productsObj = products?.map(product => {
		valueTotal += toNumber(product?.price) * toNumber(product?.quantity)
		return {
			'item_name': product?.name,
			'item_id': product?.id,
			'item_brand': product?.productDetail?.brands?.brandname,
			'item_category': product?.productDetail?.categories?.categoryname,
			'price': toNumber(product?.price),
			'quantity': toNumber(product?.quantity)
		}
	})

	window.gtag("event", "add_to_cart", {
		currency: "THB",
		value: valueTotal,
		items: productsObj
	});
};


const gtmProductRemoveFromCart = ({ products = [] }) => {
	let valueTotal = 0;
	const productsObj = products?.map(product => {
		valueTotal += toNumber(product?.price) * toNumber(product?.quantity)
		return {
			'item_name': product?.name,
			'item_id': product?.id,
			'item_brand': product?.productDetail?.brands?.brandname,
			'item_category': product?.productDetail?.categories?.categoryname,
			'price': toNumber(product?.price),
			'quantity': toNumber(product?.quantity)
		}
	})

	window.gtag("event", "remove_from_cart", {
		currency: "THB",
		value: valueTotal,
		items: productsObj
	});
};


const gtmCheckout = ({ products = [], checkoutOption }) => {
	let valueTotal = 0;
	const productsObj = products?.map(product => {
		valueTotal += toNumber(product?.special_priceforsales) * toNumber(product?.orderAmount)
		return {
			'item_name': product?.productname,
			'item_id': product?.productcode,
			'item_brand': product?.brands?.brandname,
			'item_category': product?.categories?.categoryname,
			'price': toNumber(product?.special_priceforsales),
			'quantity': toNumber(product?.orderAmount)
		};
	});

	window.gtag('event', 'begin_checkout', {
		currency: "THB",
		value: valueTotal,
		items: productsObj,
	});

	window.gtag("event", "add_payment_info", {
		currency: "THB",
		value: valueTotal,
		items: productsObj,
		payment_type: checkoutOption,
	});
};

const gtmPurchases = ({ products = [], orderObj = {} }) => {
	const productsObj = products?.map(product => {
		return {
			'item_name': product?.productname,
			'item_id': product?.productcode,
			'item_brand': product?.brands?.brandname,
			'item_category': product?.categories?.categoryname,
			'price': toNumber(product?.special_priceforsales),
			'quantity': toNumber(product?.orderAmount)
		}
	})

	window.gtag('event', 'purchase', {
		currency: "THB",
		items: productsObj,
		value: orderObj?.revenue,
		transaction_id: orderObj?.id,
		coupon: orderObj?.coupon,
		shipping: orderObj?.shipping,
	});
};


export {
	gtmProductImpression,
	gtmProductClick,
	gtmProductDetail,
	gtmProductAddToCart,
	gtmProductRemoveFromCart,
	gtmCheckout,
	gtmPurchases
}